if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.cartNotification = document.getElementById('cart-notification');
      this.cartNotificationItem = document.getElementById('cart-notification-item');
      this.multi_item_request = false;
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay').classList.remove('hidden');

      const upsell_ids_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-id`);
      const upsell_quantities_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-quantity`);
      let upsell_items = [];

      if (upsell_ids_nodes.length !== 0) {
        const upsell_ids = Array.from(upsell_ids_nodes).map(input => parseInt(input.value));
        const upsell_quantities = Array.from(upsell_quantities_nodes).map(input => parseInt(input.value));
        upsell_items = upsell_ids
          .map((id, index) => ({ 'id': id, 'quantity': upsell_quantities[index] }))
          .filter(item => item.quantity !== 0);
      }

      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        }
      };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);

      if (upsell_items.length > 0) {
        this.multi_item_request = true;
        const items = upsell_items;
        const id = parseInt(formData.get('id'));
        const quantity = parseInt(formData.get('quantity')) || 1;
        items.push({ 'id': id, 'quantity': quantity });
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify({ 'items': items });
      } else {
        this.multi_item_request = false;
        config.body = formData;
      }

      try {
        const res = await fetch(routes.cart_add_url + '.js', config);
        const json = await res.json();

        if (res.status !== 200) throw new Error(json.description);

        if (this.cartNotification) {
          const cartData = await this.fetchCart();
          const notificationTemplate = document.importNode(this.cartNotification.content, true);

          if (this.multi_item_request) {
            notificationTemplate.querySelector('[data-notification-title]').textContent = window.variantStrings.itemsAdded;
            let lastElement = json.items.pop();
            json.items.unshift(lastElement);
            json.items.forEach(item => {
              notificationTemplate.querySelector('[data-items]').appendChild(this.createNotificationItem(item));
            });
          } else {
            notificationTemplate.querySelector('[data-notification-title]').textContent = window.variantStrings.itemAdded;
            notificationTemplate.querySelector('[data-items]').appendChild(this.createNotificationItem(json));
          }

          const progressWrapper = notificationTemplate.querySelector('[data-progress-bar]');
          if (progressWrapper && cartData) {
            // ← Pass full cartData for progress bar rendering
            progressWrapper.innerHTML = this.buildProgressBar(cartData);
          }

         document.querySelector('.cart-notification')?.remove();
            document.body.appendChild(notificationTemplate);

            const the_notification = document.querySelector('.cart-notification');

            if (cartData) this.renderSubtotal(the_notification, cartData);

            the_notification.setAttribute('tabindex', '-1');
            the_notification.focus();

            the_notification.querySelector('.notification-close').addEventListener('click', () => {
              the_notification.classList.remove('anim-in');
            });

            setTimeout(() => the_notification.classList.add('anim-in'), 50);

            if (cartData) this.updateCheckoutDiscount(the_notification, cartData);

            const primaryProductId = formData.get('product-id') || null;
            if (primaryProductId) {
              requestAnimationFrame(() => this.loadUpsellProducts(the_notification, primaryProductId));
            }
        }

        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

      } catch (error) {
        this.handleErrorMessage(error);
        console.error(error);
      }

      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay').classList.add('hidden');
      this.resetQuantityInput();
    }

    // ─── CART FETCH ───────────────────────────────────────────────────────────

    async fetchCart() {
      try {
        const rootUrl = window.routes?.root === '/' ? '/' : (window.routes?.root || '') + '/';
        const res = await fetch(rootUrl + 'cart.js');
        if (!res.ok) return null;
        return await res.json();
      } catch (e) { return null; }
    }

    // ─── MONEY FORMATTER ─────────────────────────────────────────────────────

    formatMoney(cents) {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}}');
      }
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD',
          minimumFractionDigits: 2
        }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    }

    // ─── DISCOUNT TIER CALCULATOR ────────────────────────────────────────────
    //
    //  Rules (highest wins, no combining):
    //    ① First logged-in order (customerOrdersCount === 0) + ≥1 item → 10% off  (code: FIRST10)
    //    ② 2 items in cart                                              → 10% off  (code: MULTI10)
    //    ③ 3+ items in cart                                             → 15% off  (code: MULTI15)

    getDiscountTier(cartData) {
      if (!cartData) return { pct: 0, code: null, qualifyingCount: 0, isFirstOrder: false };

      // window.customerOrdersCount is set in theme.liquid:
      //   -1 → guest (unknown)
      //    0 → logged-in, never ordered (first-time)
      //   1+ → returning customer
      const isFirstOrder = typeof window.customerOrdersCount === 'number'
        && window.customerOrdersCount === 0;

      const items = cartData.items || [];

      const qualifyingCount = items.reduce((n, i) => n + i.quantity, 0);

      // Evaluate tiers highest → lowest; first match wins
      if (qualifyingCount >= 3) return { pct: 15, code: 'Special  Deal', qualifyingCount, isFirstOrder };
      if (qualifyingCount >= 2) return { pct: 10, code: 'Best Offer', qualifyingCount, isFirstOrder };
      if (isFirstOrder && qualifyingCount >= 1) return { pct: 10, code: 'First Order 10% Off', qualifyingCount, isFirstOrder };

      return { pct: 0, code: null, qualifyingCount, isFirstOrder };
    }

    // ─── CHECKOUT DISCOUNT WIRING ─────────────────────────────────────────────
    //
    //  When a discount is active, swap the checkout button so it redirects to
    //  /discount/CODE?redirect=%2Fcheckout  which applies the code then proceeds.

    updateCheckoutDiscount(notificationEl, cartData) {
      const { code } = this.getDiscountTier(cartData);

      const checkoutForm = notificationEl.querySelector('#cart-notification-form');
      if (!checkoutForm) return;

      const checkoutBtn = checkoutForm.querySelector('[name="checkout"]');
      if (!checkoutBtn) return;

      // Guard: only bind once per notification
      if (checkoutBtn.dataset.discountBound) return;
      checkoutBtn.dataset.discountBound = 'true';

      if (code) {
        // Override default form submit → redirect via discount URL
        checkoutBtn.type = 'button';
        checkoutBtn.addEventListener('click', () => {
          window.location.href = `/discount/${code}?redirect=%2Fcheckout`;
        });
      }
      // No code → leave the form submit behaviour untouched
    }

    // ─── SUBTOTAL WITH DISCOUNT BREAKDOWN ────────────────────────────────────

renderSubtotal(notificationEl, cartData) {
  const subtotalRow = notificationEl.querySelector('[data-subtotal-row]');
  if (!subtotalRow) return;

  const { pct, code } = this.getDiscountTier(cartData);

  const items = cartData.items || [];
  const qualifyingTotal = items.reduce((sum, item) => sum + (item.original_line_price || item.final_line_price || 0), 0);

  const discountAmount  = Math.round(qualifyingTotal * pct / 100);
  const discountedTotal = qualifyingTotal - discountAmount;

  if (pct > 0 && code) {
    subtotalRow.innerHTML = `
      <div class="notif-subtotal-breakdown">

        <div class="notif-subtotal-line">
          <span class="notif-subtotal-label">Subtotal</span>
          <span class="notif-subtotal-original" data-subtotal-amount>
            ${this.formatMoney(qualifyingTotal)}
          </span>
        </div>

        <div class="notif-subtotal-line notif-discount-line">
          <span class="notif-discount-badge">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            ${code} &nbsp;·&nbsp; ${pct}% off
          </span>
          <span class="notif-discount-saving">−${this.formatMoney(discountAmount)}</span>
        </div>

        <div class="notif-subtotal-line notif-total-final-line">
          <span class="notif-subtotal-label-final">Total at checkout</span>
          <span class="notif-subtotal-final">${this.formatMoney(discountedTotal)}</span>
        </div>

      </div>`;
  } else {
    subtotalRow.innerHTML = `
      <span class="notif-subtotal-label">Subtotal</span>
      <span class="notif-subtotal-amount" data-subtotal-amount>
        ${this.formatMoney(qualifyingTotal)}
      </span>`;
  }

  subtotalRow.removeAttribute('hidden');
}

    // ─── PROGRESS BAR ─────────────────────────────────────────────────────────
    //
    //  3-milestone track: Start · 2 items (10% off) · 3 items (15% off)
    //  If this is a first-order customer, messaging reflects the bonus 10%.

    buildProgressBar(cartData) {
      const TIER_1 = { items: 2, discount: '10%' };
      const TIER_2 = { items: 3, discount: '15%' };

      const { qualifyingCount, isFirstOrder } = this.getDiscountTier(cartData);

      const tier1Unlocked = qualifyingCount >= TIER_1.items;
      const tier2Unlocked = qualifyingCount >= TIER_2.items;
      let fillPercent   = Math.round(Math.min((qualifyingCount / TIER_2.items) * 100, 100));
         if(fillPercent < 50 )
          fillPercent = 0;
    else if(fillPercent > 50 && fillPercent < 100)
            fillPercent = 50;
      const milestone0Pct = 0;
      const milestone1Pct = 50;   // midpoint = TIER_1
      const milestone2Pct = 100;  // end      = TIER_2

      // ── Status message ───────────────────────────────────────────────────────
      let messageHtml;

      if (tier2Unlocked) {
        // Best tier reached
        messageHtml = `<div class="notif-progress-congrats">
          <span class="notif-progress-congrats-icon" aria-hidden="true">🎉</span>
          <span>Congratulations! <strong>${TIER_2.discount} off</strong> has been unlocked!</span>
        </div>`;

      } else if (tier1Unlocked) {
        // 2 items → 10% locked in; 1 more for 15%
        const needed = TIER_2.items - qualifyingCount;
        messageHtml = `<p class="notif-progress-msg">
          <strong>${TIER_1.discount} off</strong> unlocked! Add <strong>${needed} more item</strong> for <strong>${TIER_2.discount} off</strong> 🎁
        </p>`;

      } else if (isFirstOrder && qualifyingCount === 0) {
        // Logged-in first-timer, empty cart so far
        messageHtml = `<p class="notif-progress-msg">
          🎁 <strong>First order: ${TIER_1.discount} off</strong> applied! Add
          <strong>${TIER_1.items} items</strong> for a bigger discount
        </p>`;

      } else if (isFirstOrder && qualifyingCount >= 1) {
        // First-timer with 1 qualifying item — 10% active, nudge to 15%
        const needed = TIER_2.items - qualifyingCount;
        messageHtml = `<p class="notif-progress-msg">
          🎉 <strong>First order: ${TIER_1.discount} off</strong> applied!
          Add <strong>${needed} more item${needed !== 1 ? 's' : ''}</strong> for <strong>${TIER_2.discount} off</strong>
        </p>`;

      } else {
        // Regular customer, below tier 1
        const needed = TIER_1.items - qualifyingCount;
        messageHtml = `<p class="notif-progress-msg">
          You are <strong>${needed} item${needed > 1 ? 's' : ''} away</strong> from <strong>${TIER_1.discount} off</strong>
        </p>`;
      }

      return `
        <div class="notif-progress${tier2Unlocked ? ' is-complete' : ''}">
          ${messageHtml}

          <div class="notif-progress-bar-wrap">
            <div class="notif-progress-track"
                 role="progressbar"
                 aria-valuenow="${fillPercent}"
                 aria-valuemin="0"
                 aria-valuemax="100">
              <div class="notif-progress-fill" style="width:${fillPercent}%"></div>

              <span class="notif-progress-dot is-unlocked"
                    style="left:${milestone0Pct}%" aria-hidden="true"></span>
              <span class="notif-progress-dot ${tier1Unlocked ? 'is-unlocked' : ''}"
                    style="left:${milestone1Pct}%" aria-hidden="true"></span>
              <span class="notif-progress-dot ${tier2Unlocked ? 'is-unlocked' : ''}"
                    style="left:${milestone2Pct}%" aria-hidden="true"></span>
            </div>

            <div class="notif-progress-labels">
              <span class="notif-progress-label is-unlocked" style="left:${milestone0Pct}%">
                Start
              </span>
              <span class="notif-progress-label ${tier1Unlocked ? 'is-unlocked' : ''}" style="left:${milestone1Pct}%">
                ${TIER_1.discount} off
              </span>
              <span class="notif-progress-label ${tier2Unlocked ? 'is-unlocked' : ''}" style="left:${milestone2Pct}%">
                ${TIER_2.discount} off
              </span>
            </div>
          </div>
        </div>`;
    }

    // ─── UPSELL SLIDER ───────────────────────────────────────────────────────

    // ── Swatch helpers ──
    getSwatchSettings() {
      return window.__shopifySwatches || { enabled: true, identifiers: ['color'], hexMap: '' };
    }

    isColorOption(optionName) {
      const s = this.getSwatchSettings();
      if (!s.enabled) return false;
      const name = (optionName || '').toLowerCase().trim();
      return s.identifiers.some(id => name === id);
    }

    getColorOptionIndex(product) {
      const opts = product.options || [];
      for (let i = 0; i < opts.length; i++) {
        if (this.isColorOption(opts[i].name || opts[i])) return i;
      }
      return -1;
    }

    getHexMap() {
      if (this._hexMap) return this._hexMap;
      this._hexMap = {};
      const raw = this.getSwatchSettings().hexMap;
      if (raw) {
        const lines = String(raw).split(/\r?\n/);
        lines.forEach(line => {
          const parts = line.split(':');
          if (parts.length >= 2) {
            const key = parts[0].trim().toLowerCase();
            const val = parts.slice(1).join(':').trim();
            if (key && val) this._hexMap[key] = val;
          }
        });
      }
      return this._hexMap;
    }

    colorNameToHex(name) {
      const merchant = this.getHexMap();
      const key = (name || '').toLowerCase().trim();
      if (merchant[key]) return merchant[key];
      const map = {
        black:'#1a1a1a',white:'#f5f5f5',red:'#d42b2b',blue:'#2b5cd4',green:'#2b8c3f',
        yellow:'#e8c62b',purple:'#7b2bd4',pink:'#e07bb5',orange:'#e07b2b',grey:'#999',
        gray:'#999',brown:'#7b4f2b',navy:'#1a2b5c',beige:'#e8dcc8',gold:'#c9a84c',
        silver:'#c0c0c0',teal:'#2b8c8c',maroon:'#7b2b2b',olive:'#6b7b2b',cream:'#faf3e0',
        charcoal:'#3a3a3a',tan:'#d4b896',ivory:'#fffff0',coral:'#e87b6b',
        burgundy:'#6b1a2b',mustard:'#d4b82b',mint:'#8fdfb8',peach:'#f0b896',
        lavender:'#c8b8e8',turquoise:'#48c8c8',khaki:'#c8b88f',
        'light blue':'#a8d0f0','dark blue':'#1a3a6b','light pink':'#f0c8d8',
        'dark green':'#1a4a2b','light green':'#a8e0b8','dark grey':'#555',
        'light grey':'#ddd','off white':'#fafaf5','sky blue':'#87ceeb'
      };
      return map[key] || null;
    }

    buildSwatches(product, variants, colorOptionIndex) {
      const colorKey = 'option' + (colorOptionIndex + 1);
      const seen = {};
      const swatches = [];
      variants.forEach(v => {
        const val = v[colorKey];
        if (!val || seen[val]) return;
        seen[val] = true;
        const color = v.swatch?.color || this.colorNameToHex(val) || null;
        swatches.push({ value: val, variantId: v.id, color });
      });
      return swatches;
    }

    _onSwatchClick(slide, pid, vid) {
      const item = (this._upsellItems || []).find(i =>
        i && String(i.product.id) === String(pid)
      );
      if (!item) return;

      const newV = item.variants.find(v => v.id === vid);
      if (!newV) return;

      item.selectedVariantId = vid;

      // Update swatch selection visuals
      slide.querySelectorAll('[data-upsell-swatch]').forEach(b => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      const activeBtn = slide.querySelector(`[data-swatch-vid="${vid}"]`);
      if (activeBtn) {
        activeBtn.classList.add('is-selected');
        activeBtn.setAttribute('aria-pressed', 'true');
      }

      // Update price
      const priceEl = slide.querySelector('.notif-upsell-price');
      if (priceEl) priceEl.textContent = this.formatMoney(newV.price);

      // Update compare price
      const compareEl = slide.querySelector('.notif-upsell-price-compare');
      if (newV.compare_at_price && newV.compare_at_price > newV.price) {
        const newCompare = this.formatMoney(newV.compare_at_price);
        if (compareEl) {
          compareEl.textContent = newCompare;
        } else {
          const wrap = slide.querySelector('.notif-upsell-price-wrap');
          if (wrap && priceEl) {
            const span = document.createElement('span');
            span.className = 'notif-upsell-price-compare';
            span.textContent = newCompare;
            wrap.insertBefore(span, priceEl);
          }
        }
      } else if (compareEl) {
        compareEl.remove();
      }

      // Update image
      const imgWrap = slide.querySelector('.notif-upsell-img-wrap');
      const newImg = newV.featured_image?.src
        ? this.resizeShopifyImage(newV.featured_image.src, '200x')
        : this.getProductImage(item.product);
      if (imgWrap && newImg) {
        const imgEl = imgWrap.querySelector('img');
        if (imgEl) imgEl.src = newImg;
        imgWrap.href = '/products/' + item.product.handle + '?variant=' + newV.id;
      }

      // Update title link
      const titleLink = slide.querySelector('.notif-upsell-title a');
      if (titleLink) titleLink.href = '/products/' + item.product.handle + '?variant=' + newV.id;

      // Update ATC button
      const atcBtn = slide.querySelector('[data-upsell-atc]');
      if (atcBtn) {
        atcBtn.setAttribute('data-variant-id', String(newV.id));
        atcBtn.setAttribute('data-product-image', newImg || '');
      }
    }

   async loadUpsellProducts(notificationEl, productId) {
  if (!productId) return;

  const upsellSection  = notificationEl.querySelector('[data-upsell-section]');
  const upsellProducts = notificationEl.querySelector('[data-upsell-products]');
  if (!upsellSection || !upsellProducts) return;

  upsellSection.removeAttribute('hidden');
  upsellProducts.innerHTML = `
    <div class="notif-upsell-header">
      <p class="notif-upsell-heading">You may also like</p>
    </div>
    ${this.buildUpsellSkeleton(1)}`;

  try {
    const rootUrl = window.routes?.root === '/' ? '/' : (window.routes?.root || '') + '/';

    // Fetch cart first to check for Set products
    const cartData = await this.fetchCart();

    // If cart contains a "Set" product, base recommendations on it instead
    let targetProductId = productId;
    if (cartData && cartData.items) {
      for (let i = 0; i < cartData.items.length; i++) {
        const title = cartData.items[i].product_title || cartData.items[i].title || '';
        if (title.indexOf('Set') !== -1 || title.indexOf('set') !== -1) {
          targetProductId = cartData.items[i].product_id;
          break;
        }
      }
    }

    const recRes = await fetch(`${rootUrl}recommendations/products.json?product_id=${targetProductId}&limit=10`);

    if (!recRes.ok) throw new Error('Recommendations failed');
    const { products = [] } = await recRes.json();

    // Cart variant ids to exclude already-in-cart variants
    const cartVariantIds = new Set((cartData?.items || []).map(i => i.variant_id));

    // One upsell entry per product with swatches (not per variant)
    const upsellItems = products.map(product => {
      const availableVariants = product.variants.filter(
        v => v.available !== false && !cartVariantIds.has(v.id)
      );
      if (availableVariants.length === 0) return null;

      const colorOptionIndex = this.getColorOptionIndex(product);
      const swatches = colorOptionIndex >= 0
        ? this.buildSwatches(product, availableVariants, colorOptionIndex) : [];

      return {
        product,
        variants: availableVariants,
        defaultVariant: availableVariants[0],
        selectedVariantId: availableVariants[0].id,
        colorOptionIndex,
        swatches
      };
    }).filter(Boolean);

    // Store for swatch click handler access
    this._upsellItems = upsellItems;
    this._upsellNotif = notificationEl;

    if (upsellItems.length === 0) {
      upsellSection.setAttribute('hidden', '');
      return;
    }

    const total = upsellItems.length;

    const slidesHtml = upsellItems.map((item, index) => {
      const { product } = item;
      const variant = item.defaultVariant;
      const pid = 'upsell-' + product.id;

      const imageUrl = variant.featured_image?.src
        ? this.resizeShopifyImage(variant.featured_image.src, '200x')
        : this.getProductImage(product);

      const price        = this.formatMoney(variant.price);
      const comparePrice = variant.compare_at_price && variant.compare_at_price > variant.price
                         ? this.formatMoney(variant.compare_at_price) : null;
      const title = this.escapeHtml(product.title);

      // Swatch dots HTML
      let swatchesHtml = '';
      if (item.swatches.length > 1) {
        swatchesHtml = '<div class="notif-upsell-swatches">' +
          item.swatches.map(s => {
            const isSel = s.variantId === item.selectedVariantId;
            const swatchColor = s.color
              ? `--swatch-color:${s.color}`
              : `--swatch-color:var(--${String(s.value).replace(/\s+/g,'-').toLowerCase()})`;
            return `<button class="notif-upsell-swatch-btn${isSel ? ' is-selected' : ''}"
              data-upsell-swatch data-swatch-vid="${s.variantId}" data-upsell-pid="${pid}"
              style="${swatchColor}" aria-label="${this.escapeHtml(s.value)}" title="${this.escapeHtml(s.value)}"
              ${isSel ? ' aria-pressed="true"' : ' aria-pressed="false"'} type="button">
              <span class="notif-upsell-swatch-color"></span></button>`;
          }).join('') + '</div>';
      }

      return `
        <div class="notif-upsell-slide${index === 0 ? ' is-active' : ''}" data-slide-index="${index}" data-upsell-pid="${pid}">
          <div class="notif-upsell-card">
            <a href="/products/${product.handle}?variant=${variant.id}" class="notif-upsell-img-wrap" tabindex="-1" aria-hidden="true">
              ${imageUrl
                ? `<img src="${imageUrl}" alt="${title}" width="80" height="80" loading="lazy">`
                : `<div style="width:100%;height:100%;background:#ddd;border-radius:8px;"></div>`}
            </a>
            <div class="notif-upsell-body">
              <p class="notif-upsell-title">
                <a href="/products/${product.handle}?variant=${variant.id}">${title}</a>
              </p>
              ${swatchesHtml}
              <div class="notif-upsell-price-wrap">
                ${comparePrice ? `<span class="notif-upsell-price-compare">${comparePrice}</span>` : ''}
                <span class="notif-upsell-price">${price}</span>
              </div>
              <button
                class="notif-upsell-atc-btn"
                type="button"
                data-upsell-atc
                data-variant-id="${variant.id}"
                data-product-id="${product.id}"
                data-product-image="${imageUrl}"
                aria-label="Add ${title} to cart">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <line x1="12" y1="5" x2="12" y2="19"/>
                  <line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
                Add to cart
                <div class="loading-overlay loading-overlay__spinner hidden" aria-hidden="true">
                  <svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"/>
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>`;
    }).join('');

    upsellProducts.innerHTML = `
      <div class="notif-upsell-header">
        <p class="notif-upsell-heading">You may also like</p>
        ${total > 1 ? `
        <div class="notif-upsell-nav">
          <button class="notif-upsell-nav-btn" data-upsell-prev aria-label="Previous">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>
          <span class="notif-upsell-counter" data-upsell-counter>1 / ${total}</span>
          <button class="notif-upsell-nav-btn" data-upsell-next aria-label="Next">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 6 15 12 9 18"/>
            </svg>
          </button>
        </div>` : ''}
      </div>
      <div class="notif-upsell-slider">${slidesHtml}</div>`;

    if (total > 1) this.initUpsellSlider(upsellProducts, total);

    upsellProducts.querySelectorAll('[data-upsell-atc]').forEach(btn => {
      btn.addEventListener('click', (e) => this.upsellAddToCart(e, notificationEl));
    });

    // Wire swatch clicks
    const self = this;
    upsellProducts.querySelectorAll('[data-upsell-swatch]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const vid = parseInt(this.dataset.swatchVid);
        if (!vid) return;
        const pid = this.dataset.upsellPid;
        const slide = this.closest('[data-upsell-pid]');
        if (!slide) return;
        self._onSwatchClick(slide, pid, vid);
      });
    });

  } catch (e) {
    console.warn('Could not load upsell products:', e);
    upsellSection.setAttribute('hidden', '');
  }
}

    // ─── UPSELL ATC ──────────────────────────────────────────────────────────

    async upsellAddToCart(e, notificationEl) {
      const btn       = e.currentTarget;
      const variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      const overlay = btn.querySelector('.loading-overlay');
      btn.disabled = true;
      overlay?.classList.remove('hidden');

      try {
        const rootUrl = window.routes?.root === '/' ? '/' : (window.routes?.root || '') + '/';
        const res = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        });

        const json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message);

        const cartData = await this.fetchCart();

        if (cartData) {
          // ← Pass full cartData for progress bar
          const progressWrapper = notificationEl.querySelector('[data-progress-bar]');
          if (progressWrapper) {
            progressWrapper.innerHTML = this.buildProgressBar(cartData);
          }

          // NEW
this.renderSubtotal(notificationEl, cartData);

          const cartTotalEl = notificationEl.querySelector('.cart-total');
          if (cartTotalEl) cartTotalEl.textContent = cartData.item_count;

          // ← Re-wire checkout button if tier changed after upsell
          this.updateCheckoutDiscount(notificationEl, cartData);
        }

        overlay?.classList.add('hidden');
        btn.innerHTML = `
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          Added`;
        btn.classList.add('is-added');
        setTimeout(() => {
          btn.disabled = false;
          btn.classList.remove('is-added');
          btn.innerHTML = `
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Add to cart
            <div class="loading-overlay loading-overlay__spinner hidden" aria-hidden="true">
              <svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"/>
              </svg>
            </div>`;
        }, 2000);

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { productId: btn.dataset.productId }
        }));

      } catch (err) {
        console.error('Upsell ATC error:', err);
        overlay?.classList.add('hidden');
        btn.disabled = false;
      }
    }

    // ─── SLIDER NAV ──────────────────────────────────────────────────────────

    initUpsellSlider(container, total) {
      let current = 0;
      const slides  = container.querySelectorAll('.notif-upsell-slide');
      const counter = container.querySelector('[data-upsell-counter]');
      const prevBtn = container.querySelector('[data-upsell-prev]');
      const nextBtn = container.querySelector('[data-upsell-next]');

      const goTo = (index) => {
        slides[current].classList.remove('is-active');
        current = (index + total) % total;
        slides[current].classList.add('is-active');
        if (counter) counter.textContent = `${current + 1} / ${total}`;
      };

      prevBtn?.addEventListener('click', () => goTo(current - 1));
      nextBtn?.addEventListener('click', () => goTo(current + 1));
    }

    // ─── IMAGE HELPERS ────────────────────────────────────────────────────────

    getProductImage(product) {
      const src = product.featured_image?.src
               || product.featured_image
               || product.images?.[0]?.src
               || product.images?.[0]
               || '';
      if (!src || typeof src !== 'string') return '';
      return this.resizeShopifyImage(src, '200x');
    }

    resizeShopifyImage(url, size = '200x') {
      if (!url || typeof url !== 'string') return '';
      if (url.startsWith('//')) url = 'https:' + url;
      url = url.replace(/_\d+x\d*(\.(jpe?g|png|gif|webp))/gi, '$1');
      return url.replace(/(\.(?:jpe?g|png|gif|webp))(\?|$)/i, `_${size}$1$2`);
    }

    buildUpsellSkeleton(count = 1) {
      return Array.from({ length: count }).map(() => `
        <div class="notif-upsell-skeleton-item">
          <div class="notif-upsell-skel-img"></div>
          <div class="notif-upsell-skel-body">
            <div class="notif-upsell-skel-line" style="width:80%"></div>
            <div class="notif-upsell-skel-line" style="width:50%"></div>
            <div class="notif-upsell-skel-line" style="width:65%"></div>
          </div>
        </div>`).join('');
    }

    escapeHtml(str) {
      const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
      return String(str).replace(/[&<>"']/g, m => map[m]);
    }

    // ─── EXISTING METHODS (unchanged) ────────────────────────────────────────

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper
        || this.querySelector('.product-form__error-message-wrapper')
        || document.querySelector(`.product-form__error-message-wrapper[form="${this.form.getAttribute('id')}"]`);
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }

    resetQuantityInput() {
      const hidden_quantity_input = document.querySelector('[type=hidden][name=quantity]');
      if (hidden_quantity_input) hidden_quantity_input.value = 1;
    }

    createNotificationItem(product) {
  const notificationItemTemplate = document.importNode(this.cartNotificationItem.content, true);

  const filename     = product.image.split('/').pop();
  const lastDotIndex = filename.lastIndexOf('.');
  const newFilename  = `${filename.substring(0, lastDotIndex)}_120x${filename.substring(lastDotIndex)}`;
  const url          = product.image.replace(filename, newFilename);

  notificationItemTemplate.querySelector('.notification-item-image').setAttribute('src', url);
  notificationItemTemplate.querySelector('.notification-item-image').classList.remove('hide');
  notificationItemTemplate.querySelector('.notification-item-title').textContent = product.product_title;

  const titleEl = notificationItemTemplate.querySelector('.notification-item-title');

  // ── Variant title (shown prominently, before qty/price) ──
  if (product.variant_title && product.variant_title !== 'Default Title') {
    const variantEl = document.createElement('p');
    variantEl.className = 'notification-item-variant';
    variantEl.textContent = product.variant_title;
    titleEl.insertAdjacentElement('afterend', variantEl);
  }

  // ── Qty + price row ──
  const qtyPrice = document.createElement('div');
  qtyPrice.className = 'notification-item-qty-price';

  const qtySpan = document.createElement('span');
  qtySpan.className = 'notification-item-qty';
  qtySpan.textContent = `Qty: ${product.quantity || 1}`;

  const sep = document.createElement('span');
  sep.className = 'notification-item-sep';
  sep.setAttribute('aria-hidden', 'true');
  sep.textContent = '·';

  const priceSpan = document.createElement('span');
  priceSpan.className = 'notification-item-price';
  priceSpan.textContent = this.formatMoney(
    product.final_line_price ?? product.final_price ?? product.price ?? 0
  );

  qtyPrice.appendChild(qtySpan);
  qtyPrice.appendChild(sep);
  qtyPrice.appendChild(priceSpan);

  // Insert qtyPrice after the last inserted element
  // (after variantEl if it exists, otherwise after titleEl)
  const insertAfter = notificationItemTemplate.querySelector('.notification-item-variant') || titleEl;
  insertAfter.insertAdjacentElement('afterend', qtyPrice);

  // ── Options (Color, Size etc.) ──
  product.options_with_values.forEach(item => {
    const row = document.createElement('dl');
    const nameCell = document.createElement('dt');
    const valueCell = document.createElement('dd');
    nameCell.textContent = item.name + ': ';
    valueCell.textContent = item.value;
    row.appendChild(nameCell);
    row.appendChild(valueCell);
    notificationItemTemplate.querySelector('.notification-item-details').appendChild(row);
  });

  // ── Line item properties ──
  const propertyKeyValues = Object.entries(product.properties);
  if (propertyKeyValues.length > 0) {
    const properties = document.createElement('dl');
    propertyKeyValues.forEach(([key, value]) => {
      if (key.startsWith('_')) return;
      const row = document.createElement('dl');
      const nameCell = document.createElement('dt');
      const valueCell = document.createElement('dd');
      nameCell.textContent = key + ': ';
      valueCell.textContent = value;
      row.appendChild(nameCell);
      row.appendChild(valueCell);
      properties.appendChild(row);
    });
    notificationItemTemplate.querySelector('.notification-item-details').appendChild(properties);
  }

  return notificationItemTemplate;
}
  });
}

class AddMultiplier extends HTMLElement {
  constructor() {
    super();

    const multiplyButton = this.querySelector('button');
    this.submitEvent = new SubmitEvent('submit', { submitter: multiplyButton });
    this.multiplyBy = parseInt(this.querySelector('[name=multiplied-quantity]').value);
    this.productForm = this.closest('product-form').querySelector('form');
    const formId = this.productForm.getAttribute('id');
    this.quantity_input = document.querySelector(`[name=quantity][form=${formId}]`);
    multiplyButton.addEventListener('click', this.submitProductForm.bind(this));
  }

  submitProductForm() {
    this.quantity_input.value = this.multiplyBy;
    this.productForm.dispatchEvent(this.submitEvent);
  }
}
customElements.define('add-multiplier', AddMultiplier);